import React from 'react';
export function Chapter9() {
  return <section className="py-8 border-t border-gray-200" data-id="element-254">
      <h2 className="text-2xl font-bold mb-6" data-id="element-255">
        Vad den "stora upptäckten" blev för mig
      </h2>
      <p className="mb-4 text-lg" data-id="element-256">
        Forskarnas whiteboard med överlappande cirklar följde mig hem.
        Upptäckten var inte en jättelik rubrik – det var ett sammanhang:
      </p>
      <ul className="list-disc pl-8 mb-6 space-y-2 text-lg" data-id="element-257">
        <li data-id="element-258">att ge hjärnan rimliga förutsättningar,</li>
        <li data-id="element-259">att stödja det som redan pågår,</li>
        <li data-id="element-260">att sänka volymen på dimman, så att livet hörs.</li>
      </ul>
      <p className="mb-4 text-lg" data-id="element-261">
        Jag slutade jaga toppar. Jag började odla stabilitet.
      </p>
      <div className="bg-white p-6 rounded-lg shadow-sm my-6" data-id="element-262">
        <h3 className="text-xl font-bold mb-3 text-[#2e7d32]" data-id="element-263">
          Värden som staplas (innan jag klickade)
        </h3>
        <ul className="space-y-4" data-id="element-264">
          <li className="flex items-start" data-id="element-265">
            <div className="bg-[#2e7d32] text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-266">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-267">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-268" />
              </svg>
            </div>
            <div data-id="element-269">
              <p className="text-lg font-medium" data-id="element-270">
                30 dagar (60 kapslar – 2/dag)
              </p>
              <p className="text-gray-600" data-id="element-271">
                En månads kontinuerligt stöd för hjärnans funktioner
              </p>
            </div>
          </li>
          <li className="flex items-start" data-id="element-272">
            <div className="bg-[#2e7d32] text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-273">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-274">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-275" />
              </svg>
            </div>
            <div data-id="element-276">
              <p className="text-lg font-medium" data-id="element-277">ca 6,23 kr/dag</p>
              <p className="text-gray-600" data-id="element-278">
                Mindre än en kopp kaffe för dagligt kognitivt stöd
              </p>
            </div>
          </li>
          <li className="flex items-start" data-id="element-279">
            <div className="bg-[#2e7d32] text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-280">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-281">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-282" />
              </svg>
            </div>
            <div data-id="element-283">
              <p className="text-lg font-medium" data-id="element-284">
                Gratis leverans (2–4 arbetsdagar)
              </p>
              <p className="text-gray-600" data-id="element-285">
                Snabb leverans inom 2-4 arbetsdagar
              </p>
            </div>
          </li>
          <li className="flex items-start" data-id="element-286">
            <div className="bg-[#2e7d32] text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-287">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-288">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-289" />
              </svg>
            </div>
            <div data-id="element-290">
              <p className="text-lg font-medium" data-id="element-291">
                180 dagars pengarna-tillbaka-garanti
              </p>
              <p className="text-gray-600" data-id="element-292">
                Prova riskfritt i upp till 6 månader
              </p>
            </div>
          </li>
          <li className="flex items-start" data-id="element-293">
            <div className="bg-[#2e7d32] text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-294">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-295">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-296" />
              </svg>
            </div>
            <div data-id="element-297">
              <p className="text-lg font-medium" data-id="element-298">Stimulantia-fritt</p>
              <p className="text-gray-600" data-id="element-299">
                Inga koffein eller andra stimulerande ämnen
              </p>
            </div>
          </li>
        </ul>
      </div>
      <p className="text-sm text-gray-600 text-center" data-id="element-300">
        När du klickar vidare kommer du till vår partners säkra checkout. Välj
        kort, Klarna eller PayPal.
      </p>
    </section>;
}